import { style } from "@vanilla-extract/css";
import { vars } from "../../../../../styles";

export const broadcastersSheet = style({
  padding: vars.space.m,
  color: vars.colors.onSurface,
});

export const broadcasterList = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
  padding: 0,
  fontSize: vars.fontSizes.body.s,
});

export const broadcasterListItem = style({
  display: "flex",
  justifyContent: "space-between",
  padding: `${vars.space.m} 0`,
  selectors: {
    "&:not(:last-child)": {
      borderBottom: vars.borders.outlineVariant,
    },
  },
});

export const broadcasterSheetHeader = style({
  textAlign: "start",
  fontSize: vars.fontSizes.heading.m,
});
